import { render, staticRenderFns } from "./CoachGames.vue?vue&type=template&id=f463b4da&"
import script from "./CoachGames.vue?vue&type=script&lang=js&"
export * from "./CoachGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports